import React from 'react';

const ExternalLinkIcon = ({ handleClick, extraClasses, size = "small" }) => {
  return (
    <button
      role="img"
      onClick={handleClick}
      className={`mls-o-svg transform ${extraClasses ? extraClasses : ""}`}>
      <span className={`oc-o-icon--external-link icon-svg fa-icon-svg fa-icon-svg--${size}`}>
        <svg viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg">
          <g fill="#707576" fillRule="nonzero" opacity=".6">
            <path d="M.527 1.09A.518.518 0 000 1.615v9.84c0 .298.228.526.527.526h9.839a.518.518 0 00.527-.527V5.833H9.84v5.095H1.054V2.143H6.15V1.09c0 .018-5.622.018-5.622 0z" />
            <path d="M5.99 6.624l4.849-4.832v1.95h1.054V0h-3.76v1.054h1.95L5.252 5.886z" />
          </g>
        </svg>
      </span>
    </button>
  );
};

export default ExternalLinkIcon;
